import styles from '@/components/workspaces/less/WorkspaceStyle.module.less';
import request from '@/utils/request';
import { List, message, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';
import UserType from '../../const/UserType';
import useUserInfo from '@/hooks/useUserInfo';
import OfficeType from '../../const/OfficeType';
import { useHistory } from 'react-router-dom';
import MallType from '@/const/MallType';

function WorkspaceCommercePlatform() {
  const userInfo = useUserInfo();
  const office = userInfo.office;
  const [platformList, setPlatformList] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    location: { state },
  } = useHistory();
  useEffect(() => {
    fetchList();
  }, []);

  function fetchList() {
    setLoading(true);
    request.getWMessage('platform-third-q-007').then((res) => {
      setPlatformList(res.data);
      if (userInfo.userType === UserType.ESHOP && office.officeType === OfficeType.PURCHASE) {
        OpenZcyMall();
      } else {
        setLoading(false);
      }
    });
  }

  function OpenZcyMall() {
    request
      .getWMessage('platform-third-q-004', { mkbm: state.mallType === MallType.Goods ? 72 : 75 })
      .then((res) => {
        if (res.data.openUrl) {
          window.open(res.data.openUrl, '_self');
        } else {
          message.error('建设中');
        }
      });
  }

  function handleItem(value) {
    request.getWMessage('platform-third-q-008', { id: value }).then((res) => {
      if (res.data.openUrl) {
        window.open(res.data.openUrl);
      } else {
        message.error('建设中');
      }
    });
  }

  return (
    <Skeleton active loading={loading}>
      <div className={styles.platformBigBox}>
        <div className={styles.platformBox}>
          <div className={styles.platformTitleBg} />
          <div className={styles.platformContent}>
            <List
              className={styles.platformListBox}
              grid={{ gutter: 16, column: 8 }}
              dataSource={platformList}
              renderItem={(i) => (
                <List.Item onClick={() => handleItem(i.id)} className={styles.platformListItem}>
                  <img
                    src={`${process.env.PUBLIC_URL}/imgs/platformImg/${i.commerceIcon}`}
                    className={styles.platformImg}
                  />
                </List.Item>
              )}
            />
          </div>
        </div>
      </div>
    </Skeleton>
  );
}

WorkspaceCommercePlatform.propTypes = {};

WorkspaceCommercePlatform.defaultProps = {};

export default WorkspaceCommercePlatform;
